export default __webpack_public_path__ + "static/media/Down.d9904f98.svg";